import { render } from "./new-receivable-account.vue?vue&type=template&id=67594e6c"
import script from "./new-receivable-account.vue?vue&type=script&lang=js"
export * from "./new-receivable-account.vue?vue&type=script&lang=js"

import "./new-receivable-account.vue?vue&type=style&index=0&id=67594e6c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__